import { formatShortName } from '@/utils/formatters'
import { getShortName } from '@/utils/participantText'
import type { ChatMessage } from '../types/ChatMessage'
import { MESSAGE_STYLES } from '../constants/ui'

/** «Иванов И.И.» */
export const formatMessageSenderShortName = (
  message: ChatMessage & { author_name?: string; name?: string },
): string => {
  const createdBy = message.created_by as
    | (NonNullable<ChatMessage['created_by']> & { middle_name?: string })
    | undefined

  if (createdBy?.last_name || createdBy?.first_name) {
    return formatShortName({
      last_name: createdBy.last_name,
      first_name: createdBy.first_name,
      middle_name: createdBy.middle_name,
    })
  }

  const fullName
    = createdBy?.full_name
    || message.author_name
    || message.name
    || createdBy?.user_name
    || createdBy?.username
    || ''

  return fullName ? getShortName(fullName) : ''
}

/**
 * Сравнивает senderId с id/MXID текущего пользователя.
 * Не путать с isMyMessage из useCurrentUser (эвристика по объекту сообщения).
 */
export const isMySender = (
  senderId: number | string,
  myId: number | string,
  matrixUserId?: string | null,
): boolean => {
  const normalizedSenderId = String(senderId)

  if (normalizedSenderId === String(myId)) {
    return true
  }

  if (matrixUserId && normalizedSenderId === matrixUserId) {
    return true
  }

  return false
}

export const getMessageStatusIcon = (
  feedback: ChatMessage['feedback'],
): { icon: string; color?: string } => {
  if (feedback?.isSeen) {
    return { icon: 'ri-check-double-line', color: 'success' }
  }
  if (feedback?.isDelivered) {
    return { icon: 'ri-check-double-line', color: 'disabled' }
  }

  return { icon: 'ri-check-line', color: 'disabled' }
}

const messageStylesCache = new Map<boolean, Record<string, string>>()

export const getMessageStyles = (isMine: boolean): Record<string, string> => {
  const cached = messageStylesCache.get(isMine)
  if (cached) {
    return cached
  }

  let styles: Record<string, string>

  if (isMine) {
    styles = MESSAGE_STYLES.MINE
  } else {
    const isDark = document.documentElement.classList.contains('v-theme--dark')
    styles = isDark ? MESSAGE_STYLES.DARK_THEME : MESSAGE_STYLES.LIGHT_THEME
  }

  messageStylesCache.set(isMine, styles)
  return styles
}
